import { render, staticRenderFns } from "./UserWithdrawalManagement.vue?vue&type=template&id=2d782ccf&scoped=true"
import script from "./UserWithdrawalManagement.vue?vue&type=script&lang=js"
export * from "./UserWithdrawalManagement.vue?vue&type=script&lang=js"
import style0 from "./UserWithdrawalManagement.vue?vue&type=style&index=0&id=2d782ccf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d782ccf",
  null
  
)

export default component.exports